import PlaylistState from "./lib/playlist-store";

function init() {
  function onAddToPlaylistClicked(event) {
    var button = event.currentTarget;

    store.addDataset(window.PLAYLIST_META);
    button.dataset.state = "clicked";
    window.setTimeout(function () {
      button.dataset.state = "ready";
    }, 1300);
  }

  var store, buttons, button, links, idx, n;

  if (!window.PLAYLIST_META) return;

  store = PlaylistState.fromLocalStorage();
  buttons = document.querySelectorAll("button.add-to-playlist");

  for (idx = 0, n = buttons.length; idx < n; idx++) {
    button = buttons[idx];
    button.addEventListener("click", onAddToPlaylistClicked);
    button.removeAttribute("x-cloak");
  }

  links = document.querySelectorAll("a.view-playlist");

  for (idx = 0, n = links.length; idx < n; idx++) {
    links[idx].removeAttribute("x-cloak");
  }
}

window.addEventListener("DOMContentLoaded", init);
